import Badge from '@cloudscape-design/components/badge';

// Presentation for each pillar: a friendly label and a unique badge colour.
// Keys are the raw pillar values emitted by the backend (see pillar_helper).
type BadgeColor = 'blue' | 'green' | 'red' | 'grey';

export const PILLAR_DISPLAY: Record<string, { label: string; color: BadgeColor }> = {
  software_services: { label: 'Software', color: 'blue' },
  foundational_services: { label: 'Foundational', color: 'green' },
  ai_services: { label: 'AI', color: 'red' },
};

// Coloured badge for a pillar. Unknown/empty pillars fall back to a grey badge
// (or an em dash when there is no pillar at all).
export default function PillarBadge({ pillar }: { pillar: string }) {
  if (!pillar) {
    return <span aria-label="No pillar">—</span>;
  }
  const display = PILLAR_DISPLAY[pillar] ?? { label: pillar, color: 'grey' as BadgeColor };
  return <Badge color={display.color}>{display.label}</Badge>;
}
